// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MessageModalContent_wrapper__3Pnyz","disabled":"MessageModalContent_disabled__1UWSX"};